import type { ReviewSort } from '@repo/api-contracts';
import type { ReactElement } from 'react';

const OPTIONS: readonly { readonly value: ReviewSort; readonly label: string }[] = [
  { value: 'LATEST', label: '최신순' },
  { value: 'RATING_DESC', label: '별점 높은순' },
  { value: 'RATING_ASC', label: '별점 낮은순' },
];

interface ReviewSortSelectProps {
  readonly value: ReviewSort;
  readonly onChange: (value: ReviewSort) => void;
}

export const ReviewSortSelect = ({ value, onChange }: ReviewSortSelectProps): ReactElement => (
  <select
    aria-label="후기 정렬"
    value={value}
    onChange={(event) => {
      const next = OPTIONS.find((option) => option.value === event.target.value);
      if (next !== undefined) onChange(next.value);
    }}
    className="h-9 border border-foreground/15 bg-background px-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
  >
    {OPTIONS.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);
